<div class="mat-search-query-builder" *transloco="let translate">
    <query-builder
        [(ngModel)]="query"
        [config]="config"
        [allowRuleset]="allowRuleset"
        [allowCollapse]="allowCollapse"
        [operatorMap]="customOperatorsMap"
        [parentTouchedCallback]="onParentChange"
        [parentChangeCallback]="onParentChange"
        [emptyMessage]="translate('A ruleset cannot be empty. Please add a rule or remove it all together.')">
        <ng-container
            *queryButtonGroup="let ruleset; let addRule = addRule; let addRuleSet = addRuleSet; let removeRuleSet = removeRuleSet">
            <material-button
                *ngIf="isAddRuleVisible"
                [hidden]="disabled"
                [classList]="['!w-[18px]', '!h-[18px]', '!text-[#3f51b5]', '!p-0', '!my-[5px]', '!mx-[10px]']"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'add'"
                [titleText]="translate('Add Rule')"
                (buttonClicked)="addRule(); openPanel()"></material-button>
            <material-button
                *ngIf="addRuleSet"
                [hidden]="disabled"
                [classList]="[
                    '!bg-transparent',
                    '!w-[18px]',
                    '!h-[18px]',
                    '!outline',
                    '!outline-2',
                    '!outline-[#3f51b5]',
                    '!text-[#3f51b5]',
                    '!p-0',
                    '!my-[5px]',
                    '!mx-[10px]'
                ]"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'add'"
                [titleText]="translate('Add Rule Set')"
                (buttonClicked)="addRuleSet(); openPanel()"></material-button>
            <material-button
                *ngIf="removeRuleSet"
                [hidden]="disabled"
                [classList]="[
                    '!bg-transparent',
                    '!w-[18px]',
                    '!h-[18px]',
                    '!outline',
                    '!outline-2',
                    '!outline-[#f44336]',
                    '!text-[#f44336]',
                    '!p-0',
                    '!my-[5px]',
                    '!mx-[10px]'
                ]"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'remove'"
                [titleText]="translate('Remove Rule Set')"
                (buttonClicked)="removeRuleSet()"></material-button>
        </ng-container>
        <ng-container *queryArrowIcon>
            <mat-icon ngClass="mat-arrow-icon" [hidden]="disabled">chevron_right</mat-icon>
        </ng-container>
        <ng-container *queryRemoveButton="let rule; let removeRule = removeRule">
            <material-button
                [hidden]="disabled"
                [classList]="['!w-[18px]', '!h-[18px]', '!text-[#f44336]', '!p-0', '!m-[5px]', '!mx-[10px]', '!my-[5px]']"
                [buttonType]="'mini-fab'"
                [prefixIcon]="'remove'"
                [titleText]="translate('Remove Rule')"
                (buttonClicked)="removeRule(rule)"></material-button>
        </ng-container>
        <ng-container *querySwitchGroup="let ruleset; let onChange = onChange">
            <material-radio-group
                *ngIf="ruleset"
                [radioOptions]="[
                    { displayName: 'AND', value: 'and' },
                    { displayName: 'OR', value: 'or' }
                ]"
                [selectedValue]="ruleset.condition"
                (selectionChanged)="onChange($event)"
                [disabled]="disabled"
                [radioGroupClassList]="['qbCondition']"
                [radioButtonClassList]="['p-[10px]', 'inline-block', 'searchType']"></material-radio-group>
        </ng-container>
        <ng-container *queryEntity="let rule; let entities = entities; let onChange = onChange">
            <mat-form-field appRemoveAriaOwns>
                <mat-label *transloco="let translate">{{ translate('Please Select One') }}</mat-label>
                <mat-select [(ngModel)]="rule.entity" (ngModelChange)="onChange($event, rule)">
                    <mat-option *ngFor="let entity of entities; trackBy: trackByEntityMethod" [value]="entity.value">
                        <span [textContent]="entity.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryField="let rule; let fields = fields; let onChange = onChange; let getFields = getFields">
            <mat-form-field appRemoveAriaOwns>
                <mat-label *transloco="let translate">{{ translate('Please Select One') }}</mat-label>
                <mat-select [(ngModel)]="rule.field" (ngModelChange)="onChange($event, rule)" (closed)="searchField = ''">
                    <mat-form-field class="customSearchFilter">
                        <input
                            matInput
                            type="text"
                            placeholder="Search Fields"
                            [(ngModel)]="searchField"
                            (click)="$event.stopPropagation()" />
                        <material-button
                            matSuffix
                            buttonType="icon"
                            size="small"
                            [titleText]="translate('Clear Search')"
                            prefixIconType="material"
                            [prefixIcon]="searchField ? 'close' : 'search'"
                            (buttonClicked)="searchField = ''"></material-button>
                    </mat-form-field>
                    <mat-option
                        *ngFor="
                            let field of getFields(rule.entity) | FilterPipe : 'name' : searchField : undefined : undefined;
                            trackBy: trackByFieldMethod
                        "
                        [value]="field.value">
                        <span [textContent]="field.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryOperator="let rule; let operators = operators; let onChange = onChange">
            <mat-form-field class="qbOperator w-[120px]" appRemoveAriaOwns>
                <mat-select [disabled]="disabled" [(ngModel)]="rule.operator" (ngModelChange)="onOperatorChange($event, rule)">
                    <mat-form-field class="customSearchFilter">
                        <input
                            matInput
                            type="text"
                            [placeholder]="translate('Search Operator')"
                            [(ngModel)]="operatorField"
                            (click)="$event.stopPropagation()" />
                        <material-button
                            matSuffix
                            buttonType="icon"
                            size="small"
                            [titleText]="translate('Clear Search')"
                            prefixIconType="material"
                            [prefixIcon]="operatorField ? 'close' : 'search'"
                            (buttonClicked)="operatorField = ''"></material-button>
                    </mat-form-field>
                    <mat-option
                        *ngFor="
                            let value of operators | FilterPipe : undefined : operatorField : undefined : undefined;
                            trackBy: trackByOperatorsMethod
                        "
                        [value]="value">
                        <span [textContent]="translate(value)"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; let options = options; type: 'category'; let onChange = onChange">
            <mat-form-field *ngIf="rule.operator !== 'IN'" appRemoveAriaOwns>
                <mat-label [textContent]="translate('Select a value')"></mat-label>
                <mat-select [disabled]="disabled" [(ngModel)]="rule.value" (ngModelChange)="onChange()">
                    <mat-form-field class="customSearchFilter">
                        <input
                            matInput
                            type="text"
                            [placeholder]="translate('Search Value')"
                            [(ngModel)]="categoryField"
                            (click)="$event.stopPropagation()" />
                        <material-button
                            matSuffix
                            buttonType="icon"
                            size="small"
                            [titleText]="translate('Clear Search')"
                            prefixIconType="material"
                            [prefixIcon]="categoryField ? 'close' : 'search'"
                            (buttonClicked)="categoryField = ''"></material-button>
                    </mat-form-field>
                    <mat-option
                        *ngFor="
                            let opt of options | FilterPipe : 'name' : categoryField : undefined : undefined;
                            trackBy: trackByOptionMethod
                        "
                        [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field *ngIf="rule.operator === 'IN'" appRemoveAriaOwns>
                <mat-label>Select value(s)...</mat-label>
                <mat-select [disabled]="disabled" [(ngModel)]="rule.value" multiple (ngModelChange)="onChange()">
                    <mat-option *ngFor="let opt of options; trackBy: trackByOptionMethod" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; let options = options; type: 'boolean'; let onChange = onChange">
            <mat-form-field appRemoveAriaOwns>
                <mat-select
                    [disabled]="disabled"
                    [placeholder]="translate('Please Select One')"
                    [(ngModel)]="rule.value"
                    (ngModelChange)="onChange()">
                    <mat-option *ngFor="let opt of options; trackBy: trackByOptionMethod" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; type: 'date'; let onChange = onChange">
            <material-input-date
                [disabled]="disabled"
                [placeholder]="'Select Date'"
                [label]="'Select Date'"
                [title]="'Select Date'"
                [model]="rule.value"
                [dateFormat]="config.fields?.[rule.field]?.['format'] || 'dd/mm/yyyy'"
                [inputOnlyDisabled]="true"
                (modelChange)="rule.value = $event; onChange()"></material-input-date>
        </ng-container>
        <ng-container *queryInput="let rule; let options = options; type: 'multiselect'; let onChange = onChange">
            <mat-form-field class="w-[300px]" appRemoveAriaOwns>
                <mat-select
                    [disabled]="disabled"
                    [placeholder]="translate('Please Select One')"
                    [(ngModel)]="rule.value"
                    multiple
                    (ngModelChange)="onChange()">
                    <mat-option *ngFor="let opt of options" [value]="opt.value">
                        <span [textContent]="opt.name"></span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'number'; let onChange = onChange">
            <mat-form-field *ngIf="rule.operator !== 'IN'" class="w-[200px]">
                <input
                    [disabled]="disabled"
                    matInput
                    [(ngModel)]="rule.value"
                    type="number"
                    [placeholder]="translate('Enter Value')"
                    (ngModelChange)="onChange()" />
            </mat-form-field>
            <mat-form-field *ngIf="rule.operator === 'IN'" class="w-[200px]" appearance="outline">
                <mat-label [hidden]="disabled">Enter value(s)...</mat-label>
                <mat-chip-grid #chipList>
                    <mat-chip-row *ngFor="let tagValue of rule.value" (removed)="removeTag(tagValue, rule)">
                        <span [textContent]="tagValue"></span>
                        <mat-icon [hidden]="disabled" matChipRemove>cancel</mat-icon>
                    </mat-chip-row>
                    <input
                        type="number"
                        [hidden]="disabled"
                        placeholder="Enter value(s)..."
                        [matChipInputFor]="chipList"
                        focused
                        (matChipInputTokenEnd)="addNewTag($event, rule)"
                        title="Type and hit Enter key or Comma to add multiple values"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur" />
                </mat-chip-grid>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'string'; let onChange = onChange">
            <mat-form-field *ngIf="rule.operator !== 'IN'">
                <input
                    [disabled]="disabled"
                    matInput
                    [(ngModel)]="rule.value"
                    (ngModelChange)="rule.value = $event.trim(); onChange()"
                    [placeholder]="translate('Enter Value')" />
            </mat-form-field>
            <mat-form-field *ngIf="rule.operator === 'IN'" appearance="outline">
                <mat-label [hidden]="disabled">Enter value(s)...</mat-label>
                <mat-chip-grid #chipList>
                    <mat-chip-row *ngFor="let tagValue of rule.value" (removed)="removeTag(tagValue, rule)">
                        <span [textContent]="tagValue"></span>
                        <mat-icon [hidden]="disabled" matChipRemove>cancel</mat-icon>
                    </mat-chip-row>
                    <input
                        [hidden]="disabled"
                        type="text"
                        placeholder="Enter value(s)..."
                        [matChipInputFor]="chipList"
                        focused
                        (matChipInputTokenEnd)="addNewTag($event, rule)"
                        title="Type and hit Enter key or Comma to add multiple values"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="addOnBlur" />
                </mat-chip-grid>
            </mat-form-field>
        </ng-container>
        <ng-container *queryInput="let rule; let field = field; type: 'textarea'; let onChange = onChange">
            <mat-form-field>
                <textarea
                    [disabled]="disabled"
                    placeholder="Enter input"
                    matInput
                    [(ngModel)]="rule.value"
                    (ngModelChange)="onChange()"></textarea>
            </mat-form-field>
        </ng-container>
    </query-builder>
    <ng-container *ngIf="isRelationConfig">
        <material-button
            [hidden]="disabled"
            class="d-flex align-items-center justify-content-end"
            (buttonClicked)="relationChanged.emit(query)"
            [text]="'Apply Relation'"></material-button>
    </ng-container>
</div>
